type SortDirection = 'asc' | 'desc';

type DateValue = Date | string | number | null | undefined;

/**
 * Creates a comparator function for sorting by date
 * @param direction - 'asc' for ascending (oldest first), 'desc' for descending (newest first)
 * @returns A comparator function that can be used with Array.sort()
 */
export function sortByDate(direction: SortDirection = 'asc') {
  return (a: DateValue, b: DateValue): number => {
    // Handle null/undefined values - place them at the end
    if (a == null && b == null) return 0;
    if (a == null) return 1;
    if (b == null) return -1;

    // Convert to Date objects and get timestamps
    const dateA = new Date(a).getTime();
    const dateB = new Date(b).getTime();

    // Handle invalid dates
    if (isNaN(dateA) && isNaN(dateB)) return 0;
    if (isNaN(dateA)) return 1;
    if (isNaN(dateB)) return -1;

    // Compare timestamps
    const comparison = dateA - dateB;

    // Return based on direction
    return direction === 'asc' ? comparison : -comparison;
  };
}
